<div class="container">
    <div>
        <img src="assets/images/logo-airlines-blue.svg" alt="Logo da Latam Azul">
    </div>

    <div class="crew-details_container">
        <app-crew-details [crew]="crew"></app-crew-details>
        
        <h5 class="message">
            VOCÊ NÃO TEM PERMISSÃO PARA ACESSAR O BENEFÍCIO, ENTRE EM CONTATO COM SUA EMPRESA PARA TER ACESSO A ESTAS FUNÇÕES  
        </h5>
    </div>
</div>